import PayerCategorizationDrawer from "./PayerCategorizationDrawer";

export default PayerCategorizationDrawer;